import React from "react"
import { Divider } from "@mui/material"

export const ThickDivider = () => {
  return <Divider sx={{ borderBottomWidth: 2 }} />
}